import uiCore = require("../core/uicore");

export class EditDeleteButtonsDirective implements uiCore.IDirective {

    public static ComponentDescription: uiCore.IStandardComponentDescription = {
        DirectiveId: "creweditdeletebuttons",
        Template: require("./creweditdeletebuttons.html"),
        AngularDependencies: [uiCore.ScopeDependency],
        Bindings: {
            onedit: "&",
            ondelete: "&"
        }
    }

    public onedit: () => void;
    public ondelete: () => void;
    
    public privateonedit() {
        if (this.onedit) this.onedit();
    }

    public privateondelete() {
        if (this.ondelete) this.ondelete();

    }
} 


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/components/creweditdeletebuttons.ts